import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../../util/constants";
import * as types from "../../types";
import {handleUnauthorizedAccess} from "../../../util/utility";

/**
 * * * * * * * * * * * * * * * * * * * * * * * * G E T U S E R L I S T * * * * * * * * * * * * * * * * * *
 */
export function getUserList(token, api_token,query,type,page) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/list/users?api_token=${api_token}&query=${query}&type=${type}&page=${page}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.GET_USER_LIST_REQUEST, types.GET_USER_LIST_RECEIVE, {
                type: types.GET_USER_LIST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetUserList = () => ({
    type: types.RESET_GET_USER_LIST,
    payload: null
});

/**
 * * * * * * * * * * * * * * * * * * * * * * * * G E T U S E R L I S T * * * * * * * * * * * * * * * * * *
 */

export function postContentInChat(token, api_token,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/chat_post?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.POST_CONTENT_IN_CHAT_REQUEST, types.POST_CONTENT_IN_CHAT_RECEIVE, {
                type: types.POST_CONTENT_IN_CHAT_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetPostContentInChat = () => ({
    type: types.RESET_POST_CONTENT_IN_CHAT,
    payload: null
});

export function getChatPost(token, api_token,idsArray) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/chat_post?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(idsArray),
            types: [types.GET_CHAT_POST_REQUEST, types.GET_CHAT_POST_RECEIVE, {
                type: types.GET_CHAT_POST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetGetChatPost = () => ({
    type: types.RESET_GET_CHAT_POST,
    payload: null
});
